import { render } from 'preact';

import PartnerNetwork from './PartnerNetwork';

const allPartners = partnerNetworkData.partners;

if (process.env.NODE_ENV === 'development') {
	console.log('debug');
	require('preact/debug');
}

const container = document.querySelector('.partner-network');

if (container) {
	render(<PartnerNetwork allPartners={allPartners} />, container);
}
